export function formatDateTime(value) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function formatDate(value) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

const SERVER_STATE_MAP = {
  active: 'online',
  stopped: 'stopped',
  offline: 'offline',
};

export function mapServerStatus(state) {
  return SERVER_STATE_MAP[state] || state || 'offline';
}

const TX_TYPE_LABELS = {
  deposit: 'Deposit',
  server_purchase: 'Server purchase',
  renewal: 'Renewal',
};

export function formatTxType(type) {
  return TX_TYPE_LABELS[type] || type || '—';
}
